import { createTheme } from '@mui/material/styles'
import { palette } from './tokens'

const theme = createTheme({
  palette: {
    mode: 'light',
    ...palette,
  },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
    h1: { fontFamily: '"Merriweather", serif', fontWeight: 700, fontSize: '2rem', lineHeight: '2.5rem' },
    h2: { fontFamily: '"Merriweather", serif', fontWeight: 700, fontSize: '1.75rem', lineHeight: '2.25rem' },
    h3: { fontFamily: '"Merriweather", serif', fontWeight: 700, fontSize: '1.5rem', lineHeight: '2rem' },
    h4: { fontFamily: '"Inter", sans-serif', fontWeight: 600, fontSize: '1.375rem', lineHeight: '1.75rem' },
    h5: { fontFamily: '"Inter", sans-serif', fontWeight: 600, fontSize: '1rem', lineHeight: '1.5rem', letterSpacing: '0.15px' },
    h6: { fontFamily: '"Inter", sans-serif', fontWeight: 600, fontSize: '0.875rem', lineHeight: '1.25rem', letterSpacing: '0.1px' },
    subtitle1: { fontWeight: 600, fontSize: '0.875rem', lineHeight: '1.25rem', letterSpacing: '0.1px' },
    subtitle2: { fontWeight: 500, fontSize: '0.75rem', lineHeight: '1rem', letterSpacing: '0.5px' },
    body1: { fontSize: '1rem', lineHeight: '1.5rem', letterSpacing: '0.5px' },
    body2: { fontSize: '0.875rem', lineHeight: '1.25rem', letterSpacing: '0.25px' },
    caption: { fontSize: '0.75rem', lineHeight: '1rem', letterSpacing: '0.4px' },
    overline: { fontSize: '0.6875rem', fontWeight: 600, lineHeight: '0.875rem', letterSpacing: '0.8px', textTransform: 'uppercase' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          padding: '8px 24px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 28,
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        enterDelay: 500,
        placement: 'top',
      },
      styleOverrides: {
        tooltip: {
          maxWidth: 280,
          fontSize: '0.75rem',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none',
        },
      },
    },
  },
})

export default theme
